var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserFrameWood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 593.565,
    height: 547.273,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style14872"
  }, ".st1{fill:#ff8b3e}.st4,.st5{opacity:.5;fill:#be2f55}.st5{fill:#fff}.st8{opacity:.8;fill:#be2f55}.st13,.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#801b34}.st28{fill:#dc634f}.st29{fill:#892334}.st29,.st31,.st32,.st34,.st35,.st38{fill-rule:evenodd;clip-rule:evenodd}.st31{opacity:.4;fill:#d9772f}.st32,.st34,.st35,.st38{fill:#e6774f}.st34,.st35,.st38{fill:#f2774f}.st35,.st38{fill:#982f34}.st38{fill:#7a1c34}.st41{opacity:.2;fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "g15274",
    transform: "translate(-171.505 -136.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14921"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 684.022,
    y1: 425.197,
    x2: 684.022,
    y2: 177.377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913300"
    },
    id: "stop14896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#aa5907"
    },
    id: "stop14898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#c4820f"
    },
    id: "stop14900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    style: {
      stopColor: "#d9a316"
    },
    id: "stop14902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#eabd1b"
    },
    id: "stop14904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#f6cf1e"
    },
    id: "stop14906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#fdda20"
    },
    id: "stop14908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde21"
    },
    id: "stop14910"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M699.33 397.94c0 .06 0 .12-.06.18-5.19 15.69-9.88 25.74-10.55 27.08 13.32-45.69 11.85-119.98-22.63-141.17 0 0-22.3-80.53-25.28-101.34-.32-2.53-.42-4.2-.12-4.72 3.37-5.74 79.52 30.13 86.51 112.77 3.44 40.66-19.6 82.19-27.87 107.2z",
    id: "path14913",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M699.33 397.94c0 .06 0 .12-.06.18-5.19 15.69-9.88 25.74-10.55 27.08 13.32-45.69 11.85-119.98-22.63-141.17 0 0-22.3-80.53-25.28-101.34l.89-.12s37.33 28.36 51.38 73.93c14.1 45.84 12.2 111.25 6.25 141.44z",
    id: "path14915"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M653.92 193.62s50.98 42.4 49.68 161.03c0 0 16.24-106.58-49.68-161.03z",
    id: "path14917"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M697.43 399.1s20.89-116.16-25.34-171.19c-34.28-40.8-5.02 80.77-5.02 80.77z",
    id: "path14919"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14948"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.66,
    y1: 423.633,
    x2: 496.66,
    y2: 179.491,
    gradientTransform: "matrix(-1 0 0 1 749.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#913300"
    },
    id: "stop14923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#aa5907"
    },
    id: "stop14925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    style: {
      stopColor: "#c4820f"
    },
    id: "stop14927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    style: {
      stopColor: "#d9a316"
    },
    id: "stop14929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#eabd1b"
    },
    id: "stop14931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    style: {
      stopColor: "#f6cf1e"
    },
    id: "stop14933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#fdda20"
    },
    id: "stop14935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffde21"
    },
    id: "stop14937"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.96 396.29c0 .06 0 .12.06.18 5.33 15.71 10.15 25.81 10.83 27.16-13.72-45.73-12.58-119.32 21.97-140.07 0 0 21.74-78.72 24.55-98.92.3-2.45.38-4.07.08-4.57-3.41-5.56-79.23 29.2-85.98 109.93-3.35 40.05 20.01 81.33 28.49 106.29z",
    id: "path14940",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M237.96 396.29c0 .06 0 .12.06.18 5.33 15.71 10.15 25.81 10.83 27.16-13.72-45.73-12.58-119.32 21.97-140.07 0 0 21.74-78.72 24.55-98.92l-.89-.11s-37.12 27.52-50.93 71.97c-13.94 44.96-11.75 109.69-5.59 139.79z",
    id: "path14942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M282.36 195.24s-50.73 41.22-48.92 157.94c0 0-16.72-104.98 48.92-157.94z",
    id: "path14944"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.93 399.1s-20.89-116.16 25.34-171.19c34.28-40.8 5.02 80.77 5.02 80.77z",
    id: "path14946"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14961"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 678.784,
    y1: 568.778,
    x2: 678.784,
    y2: 286.839
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#690f2c"
    },
    id: "stop14950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c24621"
    },
    id: "stop14952"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M763.05 379.06C752.23 435.55 698 500.83 641.64 540.94c-16.59 11.75-33.33 21.36-49.15 27.84 2.97-3.37 95.07-109.16 122.92-188.12 27.54-78.3-3.07-85.88-1.64-92.76.77-3.79 19.86 2.47 34.41 20.78l.11.06c11.96 14.91 20.97 37.93 14.76 70.32z",
    id: "path14955",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M763.05 379.06C752.23 435.55 698 500.83 641.64 540.94c-11.93 6.39-21.61 10.76-26.59 11.31 0 0 97.85-90.63 123.78-148.48 25.43-56.79 9.36-95.1 9.36-95.1l.11.06c11.95 14.92 20.96 37.94 14.75 70.33z",
    id: "path14957"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M668.22 498.64s64.82-76.19 74.58-110.07c9.66-33.56 10.14-55.62 10.14-55.62s21.76 64.25-84.72 165.69z",
    id: "path14959"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14974"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 489.01,
    y1: 570.065,
    x2: 489.01,
    y2: 286.192,
    gradientTransform: "matrix(-1 0 0 1 749.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#690f2c"
    },
    id: "stop14963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c24621"
    },
    id: "stop14965"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.54 377.15c10.96 56.46 66.26 122.66 124.2 163.95 17.15 12.17 34.48 22.16 50.85 28.96-3.1-3.49-98.37-111.83-126.98-191.09-27.93-77.61 2.78-84.97 1.31-91.74-.79-3.72-19.92 2.38-34.48 20.34l-.12.05c-11.97 14.68-21.03 37.38-14.78 69.53z",
    id: "path14968",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M173.54 377.15c10.96 56.46 66.26 122.66 124.2 163.95 12.3 6.64 22.3 11.2 27.43 11.81 0 0-100.71-92.82-127.16-151-25.7-56.57-9.57-94.33-9.57-94.33l-.12.05c-11.97 14.67-21.03 37.37-14.78 69.52z",
    id: "path14970"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.2 497.84s-66.29-77.22-76.22-111.12c-9.78-33.39-10.28-55.22-10.28-55.22s-21.91 63.65 86.5 166.34z",
    id: "path14972"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g15200"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.74,
    y1: 591.412,
    x2: 467.74,
    y2: 157.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4f092a"
    },
    id: "stop14976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a13a1a"
    },
    id: "stop14978"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.62 157.84c-106.52 0-195.94 73.3-220.58 172.19a228.926 228.926 0 0 0-2.54 34.04c0 125.58 101.81 227.34 227.34 227.34 106.52 0 195.92-73.22 220.6-172.11 1.67-11.14 2.54-22.52 2.54-34.1 0-125.53-101.79-227.36-227.36-227.36zm198.47 256.31v.04c-22.27 86.49-100.81 150.43-194.25 150.43-110.72 0-200.55-89.8-200.55-200.55 0-9.83.72-19.5 2.09-28.95-.02-.02-.02-.04 0-.04 14.05-97.01 97.58-171.58 198.45-171.58 110.74 0 200.57 89.82 200.57 200.57.01 17.29-2.19 34.06-6.31 50.08z",
    id: "path14981",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.627,
    y1: 612.542,
    x2: 465.627,
    y2: 157.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c2747"
    },
    id: "stop14983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d65731"
    },
    id: "stop14985"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.62 157.84c-106.52 0-195.94 73.3-220.58 172.19-4.42 17.66-6.76 36.15-6.76 55.17 0 125.58 101.81 227.34 227.34 227.34 113.98 0 208.36-83.84 224.83-193.24 1.67-11.14 2.54-22.52 2.54-34.1-.01-125.53-101.8-227.36-227.37-227.36zM271.39 335.12c-.02-.02-.02-.04 0-.04 22.27-86.51 100.81-150.45 194.23-150.45 110.74 0 200.57 89.82 200.57 200.57 0 9.83-.72 19.5-2.09 28.95v.04c-14.05 97.01-97.58 171.56-198.48 171.56-110.72 0-200.55-89.8-200.55-200.55 0-17.28 2.2-34.06 6.32-50.08z",
    id: "path14988",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M690.44 419.31c1.67-11.14 2.54-22.52 2.54-34.1 0-125.53-101.78-227.36-227.36-227.36-106.52 0-195.94 73.3-220.58 172.19 16.42-109.39 110.83-193.32 224.8-193.32 125.58 0 227.36 101.83 227.36 227.36 0 19.05-2.34 37.54-6.76 55.23z",
    id: "path14990"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g15198"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14993"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M465.63 157.85c-125.53 0-227.35 101.81-227.35 227.35 0 125.57 101.81 227.35 227.35 227.35 125.57 0 227.35-101.77 227.35-227.35-.01-125.54-101.78-227.35-227.35-227.35zm0 427.9c-110.74 0-200.56-89.81-200.56-200.56s89.81-200.56 200.56-200.56 200.56 89.81 200.56 200.56-89.82 200.56-200.56 200.56z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    },
    id: "use14995"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_10_)",
    id: "g15196",
    style: {
      clipPath: "url(#SVGID_10_)"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon14998",
    d: "m280.92 601 262.7 4.56-192.64-13.37z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g15084",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.356,
    y1: 241.742,
    x2: 788.724,
    y2: 241.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15002"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.36 200.72s101.7-27.08 200.69-21.77c99 5.31 140.39 13.82 268.82 21.77 128.43 7.95 145.85 73.58 145.85 73.58l-6.57 30.93s-44.91-78.63-176.96-98.69c-132.06-20.05-170.89-13.27-284.46-15.39-113.57-2.12-143.67 25.16-143.67 25.16z",
    id: "path15005",
    style: {
      fill: "url(#SVGID_11_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.723,
    y1: 325.895,
    x2: 723.477,
    y2: 325.895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15009"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.72 240.11s36.11-16.59 210.19-15.53c174.07 1.06 292.42 18.57 321.08 54.66 28.66 36.09-3.71 91.28-150.72 118.35-147.01 27.07-360.2 29.66-360.2 29.66l-.68-6.83s242 5.13 366.54-27.07c124.54-32.2 153.2-99.42 124.54-122.77-28.66-23.35-334.98-73.75-507.85-18.3z",
    id: "path15012",
    style: {
      fill: "url(#SVGID_12_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.782,
    y1: 317.549,
    x2: 622.44,
    y2: 317.549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15016"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.78 320.27s267.55-89.88 420.66-18.31c0 0-14.32 58.83-135.81 58.83-121.49 0-100.27-43.2-151.21-53.07C284.47 297.85 204.81 333 204.81 333z",
    id: "path15019",
    style: {
      fill: "url(#SVGID_13_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.407,
    y1: 405.956,
    x2: 767.642,
    y2: 405.956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15023"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.41 450.14s424.54-36.09 561.23-94.56l-2.09 11.86S477.2 437.22 206.4 456.33v-6.19z",
    id: "path15026",
    style: {
      fill: "url(#SVGID_14_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.687,
    y1: 447.485,
    x2: 758.765,
    y2: 447.485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15030"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210.69 483.87s428.69-4.45 548.08-77.91l-1.36 7.73s-140.27 65.38-546.13 75.33z",
    id: "path15033",
    style: {
      fill: "url(#SVGID_15_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.429,
    y1: 548.572,
    x2: 760.355,
    y2: 548.572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15037"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.43 581.12s347.12-123.95 539.93-70.94l-3.47 20.63s-76.16-41.92-289.86-7.25c-213.7 34.67-234.93 76.59-234.93 76.59l-9.9-.17z",
    id: "path15040",
    style: {
      fill: "url(#SVGID_16_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.434,
    y1: 540.651,
    x2: 683.561,
    y2: 540.651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15044"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M683.56 541.24s-99.07-41.75-244.13 12.03c0 0 176.2 9.91 244.13-12.03z",
    id: "path15047",
    style: {
      fill: "url(#SVGID_17_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.235,
    y1: 572.979,
    x2: 755.432,
    y2: 572.979
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15051"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M522.23 604.08s140.9-20.85 233.2-63.43l-1.09 7.92s-120.31 38.01-225.39 56.73z",
    id: "path15054",
    style: {
      fill: "url(#SVGID_18_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.783,
    y1: 326.348,
    x2: 679.321,
    y2: 326.348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15058"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.78 285.15s127.53-53.66 295.24-45.04c167.71 8.62 192.72 49.27 192.29 74.18-.42 24.91-140.99 105.24-479.5 98.87l.44-3.36s184.33 5.84 327.27-27.77c142.94-33.61 154.26-72.53 130.91-99.42-23.34-26.89-236.3-73.28-466.65 2.54z",
    id: "path15061",
    style: {
      fill: "url(#SVGID_19_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 514.088,
    y1: 428.556,
    x2: 657.733,
    y2: 428.556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15065"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M514.09 439.7s83.85-3.89 143.65-22.29z",
    id: "path15068",
    style: {
      fill: "url(#SVGID_20_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 622.44,
    y1: 594.795,
    x2: 706.205,
    y2: 594.795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15072"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon15075",
    style: {
      fill: "url(#SVGID_21_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "m643.93 607.31-21.49-2 83.77-23.02z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 676.308,
    y1: 199.85,
    x2: 782.511,
    y2: 199.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15079"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M782.51 219.81s-27.13-41.53-106.2-39.87c0 0 73.89 3.25 106.2 39.87z",
    id: "path15082",
    style: {
      fill: "url(#SVGID_22_)",
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 357.882,
    y1: 314.293,
    x2: 591.394,
    y2: 314.293
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15088"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.08 292.52s113.04-24.94 152.31 16.98c0 0-42.46 38.74-117.82 33.43-75.36-5.31-115.69-40.97-115.69-40.97s51.06 40.67 120.05 36.19c69-4.47 72.6-55.19-38.85-45.63z",
    id: "path15091",
    style: {
      fill: "url(#SVGID_23_)",
      opacity: 0.2,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    id: "polygon15093",
    d: "m439.43 475.92 176.2-8.98-62.71 7.35z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15095",
    d: "m188.69 272.91-2.61-11.01 44.43 22.01z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15097",
    d: "M773.22 347.3 311 367.44l463.09-24.23z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15099",
    d: "m583.43 466.94 39.01-1.41-183.01 12.74L314.63 497 213 505.16l226.43-29.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.982,
    y1: 598.135,
    x2: 522.235,
    y2: 598.135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c77cbd"
    },
    id: "stop15101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#974577"
    },
    id: "stop15103"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon15106",
    style: {
      fill: "url(#SVGID_24_)",
      opacity: 0.6,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "m377.86 602.68 144.37 1.4-171.25-11.89z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M206.41 456.33s165.82-13.26 315.83-39.89c-.01 0-97.4 24.32-315.83 39.89z",
    id: "path15108"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M534.34 414.32s196.81-35.29 235.55-48.91l-1.46 4.45c0-.01-148.27 30.39-234.09 44.46z",
    id: "path15110"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    id: "polygon15112",
    d: "m511.25 358.72-93.69 4.08 38.77 4.64z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15114",
    d: "m511.25 358.72-49.33-4.8-44.36 8.88 32.8.28z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15116",
    d: "m655.61 351.96-3.49 1.2 27.2 12.24z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15118",
    d: "m793.17 253.37 3.01-14.2-37.41 28.4z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15120",
    d: "m321.73 491.14-7.33.92 30.21-16.14z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15122",
    d: "m630.67 564.77-39.28 5.13-20.69 9.73 20.52-13.44z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15124",
    d: "m412.11 456.33-29.64 4.69 8.14-4.69z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon15126",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#a73234"
    },
    d: "m682.15 178.94 19.1 16.28-31.05-21.23-35.29-21.05-8.68-18.73 37.11 17.34z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15128",
    d: "m632.52 147.77-6.29-13.56 37.11 17.34 15.98 23.28 21.93 20.39-27.06-21.23z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    id: "polygon15130",
    d: "m591.39 569.9-15.75 7.41 49.12-11.77z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    id: "polygon15132",
    d: "m412.11 456.33-29.64 4.69 14.82 2.03z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    id: "polygon15134",
    d: "m327.74 490.34-6.01.8 22.88-15.22z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    id: "polygon15136",
    d: "m643.93 353.02 7.02-.39 18.15 8.17z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    id: "polygon15138",
    d: "m793.17 253.37-30.61 12.64 29.68-8.25z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    id: "polygon15140",
    d: "m679.32 180.22-17.17-11.03 6.95 7.37z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    id: "polygon15142",
    d: "m230.51 283.91-41.82-11-4.35 3.15z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15144",
    d: "m273.5 439.7-29.01 2.83 7.96-2.83z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15146",
    d: "m260.41 520.27-12.03 3.12h-3.89l11.49-3.12z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15148",
    d: "m710.8 418.91-3.18 4.6-6.01-1.06 6.01-3.54z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15150",
    d: "M686.66 579.63h-22.34l34.81-8.2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15152",
    d: "m232.1 528.15-1.85-2.35 6.36 2.35z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    id: "polygon15154",
    d: "m707.62 423.51-2.8-.49 3.78-.92z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g15168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15156",
    d: "m213.49 212.59-3.04 2.52-6.18-1.77 4.35-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15158",
    d: "m310.1 202.4-3.04 5.88h-7.5l-3.85-5.88 3.04-3.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    id: "polygon15160",
    d: "m332.59 213.48-3.89 2.5-3.61-2.74v-1.31l1.42-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    id: "polygon15162",
    d: "M305.79 207.82h1.5l-.23.46-7.5.46-3.85-6.34 3.8 4.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    id: "polygon15164",
    d: "m330.22 214.79 2.37-1.31-3.11 2.5h-.78l-3.61-2.74 2.56 1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    id: "polygon15166",
    d: "m211.99 215.65 1.5-3.06-2.57 1.53-6.65-.78 3.77 1.77z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15170",
    d: "m394.85 520.27 40.7-3.79-67.58 11.67 2.28-.67z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "m665.72 224.54-31.34-8.56-42.99-.33s38.8 1.94 74.33 8.89z",
    id: "path15172"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "m193.89 375.31 10.38 30.65 25.98 7.55-25.33.81 3.96 26.8 4.12 64.04s-11.68-94.12-19.11-129.85z",
    id: "path15174"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    id: "polygon15176",
    d: "m692.05 463.05 56.97-1.77 24.2-113.98L746.9 452z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M747.55 609.11v-58.43l18.32-65.34 4.61-13.44s-9.34 40.33-15.04 71.12c-5.72 30.77-7.89 66.09-7.89 66.09z",
    id: "path15178"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15180",
    d: "m749.9 553.63-2.35-2.95-28.04 8.37z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15182",
    d: "m221.75 588.12-1.32-7 58.99-19.06z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    id: "polygon15184",
    d: "m222.2 599.98-9.2-94.82 9.28 56.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon15186",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#b64034"
    },
    d: "m302.9 167.49-6.58.31 19.28 21.23z"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    id: "polygon15188",
    d: "m315.6 189.03-16.51-18.18 2.41 7.41z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "polygon15190",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#9d2b34"
    },
    d: "m486.63 337.31-204.64 5.9-78.78-6.97h58.97z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    id: "polygon15192",
    d: "m486.63 337.31-283.42-1.07 78.78 3.48z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    id: "polygon15194",
    d: "m228.79 413.09-24.28-5.14-5.02-.64 4.78-1.35z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g15240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15219"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.603,
    y1: 680.003,
    x2: 606.603,
    y2: 422.358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c2747"
    },
    id: "stop15202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d65731"
    },
    id: "stop15204"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M733.12 534.66c-9.85 39.33-154.83 51.62-198.84 78.49-36.25 22.13-31.26 32.91-24.58 36.83 1.58.91 3.22 1.42 4.49 1.65 6.41 1.12-4.97-16.58 14.27-21.23 19.05-4.55 19.83 16.61 14.51 23.52 0 0-16.88 27.06-43.8 26.06-22.35-.87-30.73-54.36-22.12-84.55v-.06c1.77-6.36 4.35-11.67 7.71-15.25 18.99-20.35 101.88 3.69 167.75-55.48 63.77-57.26 80.16-93.69 83.5-101.72 1.11-2.71 2.26 4.77 2.94 17.27v.12c1.21 24.55.57 68.61-5.83 94.35z",
    id: "path15207",
    style: {
      fill: "url(#SVGID_25_)"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M733.12 534.66c-9.85 39.33-154.83 51.62-198.84 78.49-36.25 22.13-31.26 32.91-24.58 36.83 0 0-27.64-26.5-12.84-62.49 14.64-35.59 86.56.02 166.73-32.09 61.4-24.68 73.12-89.12 75.38-115.1 1.19 24.56.55 68.62-5.85 94.36z",
    id: "path15209"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M542.98 653.91s-16.88 27.06-43.8 26.06c-22.35-.87-30.73-54.36-22.12-84.55-.07 2.55-1 61.78 23 72.3 24.37 10.68 36.64-19.4 37.23-26.27.52-6.91-8.82-11.07-8.82-11.07 19.05-4.53 19.83 16.63 14.51 23.53z",
    id: "path15211"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.93 570.19s76.53 1.35 122.63-31.24c45.16-31.92 54.47-83.79 54.47-83.79s-2.15 67.56-62.12 95.71c-53.56 25.13-114.98 19.32-114.98 19.32z",
    id: "path15213"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M508.98 576.87c-11.35 5.89-20.02 33.33-11.4 47.11 8.62 13.78 21.39-11.16 78.91-28.55 56.33-17.03-34.86-35.51-67.51-18.56z",
    id: "path15215"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M492.76 662.31c-5.19-14.75 20.37-3.58 31.42-8.6 11-5-.1 16.83-14.94 16.26-14.91-.58-16.48-7.66-16.48-7.66z",
    id: "path15217"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g15238"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.672,
    y1: 684,
    x2: 415.672,
    y2: 418.315,
    gradientTransform: "matrix(-1 0 0 1 749.061 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8c2747"
    },
    id: "stop15221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#d65731"
    },
    id: "stop15223"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.56 531.62c10.14 40.21 159.23 54.29 205.14 82.47 38.03 23.35 33.05 34.48 26.17 38.48-1.62.92-3.33 1.44-4.65 1.66-6.65 1.08 4.87-17.17-15.21-22.22-19.84-4.93-20.32 17.01-14.68 24.25 0 0 18.02 28.42 46.06 27.72 23.31-.62 30.9-56.24 21.31-87.59v-.07c-1.97-6.58-4.75-12.09-8.31-15.82-20.05-21.12-105.26 2.75-173.54-58.39-65.32-58.48-82.02-95.19-85.41-103.25-1.13-2.72-2.28 4.76-2.96 17.28v.12c-1.17 24.68-.47 69.18 6.08 95.36z",
    id: "path15226",
    style: {
      fill: "url(#SVGID_26_)"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M202.56 531.62c10.14 40.21 159.23 54.29 205.14 82.47 38.03 23.35 33.05 34.48 26.17 38.48 0 0 28.23-27.2 12.14-64.57-15.82-36.74-89.5-.88-172.27-34.6-62.9-25.72-74.93-91.01-77.25-117.13-1.18 24.67-.48 69.17 6.07 95.35z",
    id: "path15228"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M399.34 656.26s18.02 28.42 46.06 27.72c23.31-.62 30.9-56.24 21.31-87.59.12 2.64 2.34 64.12-22.46 74.79-25.2 10.84-38.48-20.65-39.2-27.79-.66-7.18 8.97-11.38 8.97-11.38-19.84-4.93-20.31 17.01-14.68 24.25z",
    id: "path15230"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.51 569.56s-78.79.63-126.29-33.11c-46.2-32.82-55.75-85.23-55.75-85.23s2.27 68.27 63.65 97.46c55.18 26.23 118.39 20.88 118.39 20.88z",
    id: "path15232"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M433.27 576.93c11.86 6.18 21.4 34.61 12.71 48.78-8.7 14.19-22.41-11.79-82.21-30.37-58.24-18.09 35.47-36.14 69.5-18.41z",
    id: "path15234"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.75 665.63c5.11-15.3-21.29-3.98-32.87-9.35-11.51-5.34.4 17.54 15.85 17.13 15.53-.42 17.02-7.78 17.02-7.78z",
    id: "path15236"
  })))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M222.74 252.18c-.79 3.17 17.72-11.75 24.42-21.13 35.2-49.28 48.42-45.49 35.2-44.14-13.22 1.36-51.88 34.28-59.62 65.27z",
    id: "path15242"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M709.76 248.5c.79 3.17-17.72-11.75-24.42-21.13-35.2-49.28-48.42-45.49-35.2-44.14 13.21 1.35 51.87 34.28 59.62 65.27z",
    id: "path15244"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 144.046,
    cy: 274.26,
    r: 19.907,
    gradientTransform: "matrix(2.379 .4458 -.4334 2.3127 28.58 -473.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba4b22"
    },
    id: "stop15248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#ab451f"
    },
    id: "stop15250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    style: {
      stopColor: "#853618"
    },
    id: "stop15252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    style: {
      stopColor: "#471d0d"
    },
    id: "stop15254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop15256"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_28_",
    cx: 320.858,
    cy: 242.055,
    r: 19.907,
    gradientTransform: "matrix(2.379 .4458 -.4334 2.3127 28.58 -473.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ba4b22"
    },
    id: "stop15261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    style: {
      stopColor: "#ab451f"
    },
    id: "stop15263"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    style: {
      stopColor: "#853618"
    },
    id: "stop15265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    style: {
      stopColor: "#471d0d"
    },
    id: "stop15267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    },
    id: "stop15269"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFrameWood);
export default __webpack_public_path__ + "static/media/user_frame_wood.3a74c8aec80cb54f7a1a1f02167b2aa1.svg";
export { ForwardRef as ReactComponent };